import React, { useState } from 'react';
import { Button, Col, Form, Input, Row } from 'antd';
import { EditOutlined } from '@ant-design/icons';

let formRef = React.createRef();

function AddParticipant(props) {
    
    const [ loading, setLoading ] = useState(false);

    const finishHandler = async (values) => {
        setLoading(true);
        await props.onClick(values);
        setLoading(false);
        formRef.current.resetFields();
    }

    if (props.group) {
        return (
            <Row>
                <Col offset={10} span={4} style={{textAlign: "center"}}>
                    <Button
                        type="primary"
                        icon={<EditOutlined />}
                        loading={loading}
                        onClick={() => finishHandler(/*{isGroup: true}*/)}
                    >
                        Gruppe anmelden
                    </Button>
                </Col>
            </Row>
        )
    }
    else {
        return (
            <>
                <Form
                    name="anm"
                    onFinish={finishHandler}
                    onFinishFailed={() => {} }
                    ref={formRef}
                >
                    <Row
                        gutter={[10,10]}
                        justify="start"
                    >
                        <Col span={8} offset={2}>
                            <Form.Item
                                name="regid"
                                hidden="true"
                                initialValue="ak6"
                            >
                            </Form.Item>
                            <Form.Item
                                name="lastName"
                                rules={[
                                    {
                                        required: true,
                                        message: "Bitte einen Nachnamen eingeben!"
                                    }
                                ]}
                            >
                                <Input placeholder="Nachname" />
                            </Form.Item>          
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                name="firstName"
                                rules={[
                                    {
                                        required: true,
                                        message: "Bitte einen Vornamen eingeben!"
                                    }
                                ]}
                            >
                                <Input placeholder="Vorname" />
                            </Form.Item>          
                        </Col>
                        <Col span={4}>
                            <Button 
                                type="primary"
                                htmlType="submit"
                                icon={<EditOutlined />}
                                loading={loading}
                            >
                                Anmelden
                            </Button>
                        </Col>
                        <Col span={2}>
                        </Col>
                    </Row>
                </Form>
            </>
        )    
    }
}

export default AddParticipant;